module.exports = __webpack_public_path__ + "img/d-min.43862809.jpg";